const components = [
	{
		name: 'inDevelopment',
		title:"开发中",
		component: () => import('@/components/public/inDevelopment'),
		icon:'#icon-gas_station'
	},{
		name: 'equipmentMonitoring',
		title:"设备状态",
		component: () => import('@/components/OperationMonitoring/stationMonitoring/EqumentStatus'),
		icon:'#icon-gas_station'
	},{
		name: 'equipmentStatusList',
			title:"设备状态列表",
			component: () => import('@/components/OperationMonitoring/stationMonitoring/EqumentStatusList'),
			icon:'#icon-gas_station'
	},{
		name: 'parkingLockStatus',
		title:"设备状态",
		component: () => import('@/components/OperationMonitoring/stationMonitoring/ParkingLockStatus'),
		icon:'#icon-gas_station'
	},{
		name: 'incomeMonitoring',
		title:"收入监控",
		component: () => import('@/components/OperationMonitoring/stationMonitoring/IncomeMonitor'),
		icon:'#icon-leijishouru'
	},{
		name: 'electricMonitoring',
		title:"用电监控",
		component: () => import('@/components/OperationMonitoring/stationMonitoring/DeviceStatus'),
		icon:'#icon-icon-monitor'
	},{
		name: 'realMonitoring',
		title:"实时充电",
		component: () => import('@/components/OperationMonitoring/ChargingMonitoring/ChargingInfo'),
		icon:'#icon-yongdianfenxi'
	},{
		name: 'alarmMonitoring',
		title:"实时告警",
		component: () => import('@/components/OperationMonitoring/ChargingMonitoring/AlarmingInfo'),
		icon:'#icon-alarm'
	},{
		name: 'alarmRrecord',
		title:"告警记录",
		component: () => import('@/components/Maintenance/Maintenance/AlarmRecord'),
		icon:'#icon-ALARM'
	},{
		name: 'repairRecord',
		title:"故障报修",
		component: () => import('@/components/Maintenance/FaultReport/FaultReport'),
		icon:'#icon-alarm'
	},{
		name: 'mapMonitoring',
		title:"地图监控",
		component: () => import('@/components/OperationMonitoring/MapMonitoring/MapMonitoring'),
		icon:'#icon-ditu'
	},{
		name: 'chargeOrder',
		title:"充电订单",
		component: () => import('@/components/OrderMonitoring/OrderRecord/ChargingOrder'),
		icon:'#icon-dingdan'
	},{
		name: 'evcsOrders',
		title:"互联互通订单",
		component: () => import('@/components/OrderMonitoring/OrderRecord/EvcsChargeOrder'),
		icon:'#icon-24gl-receipt'
	},{
		name: 'occupyOrder',
		title:"占位订单",
		component: () => import('@/components/OrderMonitoring/OccupyOrder/OccupyOrder'),
		icon:'#icon-dingdan'
	},{
		name: 'chargePeriodDetail',
		title:"充电时段明细",
		component: () => import('@/components/OrderMonitoring/ChargePeriodDetail/ChargePeriodDetail'),
		icon:'#icon-dingdan'
	},{
		name: 'exceptionOrders',
		title:"异常订单",
		component: () => import('@/components/OrderMonitoring/OrderRecord/AbnormalOrder'),
		icon:'#icon-lixianjisuan'
	},{
		name: 'manualSettleOrder',
		title:"充电订单",
		component: () => import('@/components/OrderMonitoring/OrderRecord/ManualSettleOrder'),
		icon:'#icon-dingdan'
	},{
		name: 'chargeRecord',
		title:"充电记录",
		component: () => import('@/components/OrderMonitoring/ChargeRecord/ChargeRecord'),
		icon:'#icon-quanju_shengji'
	},{
		name: 'offlineRecord',
		title:"离线卡记录",
		component: () => import('@/components/OrderMonitoring/OfflineCardRecord/OfflineCardRecord'),
		icon:'#icon-lixian'
	},{
		name: 'offlinePeriodDetail',
		title:"充电时段明细",
		component: () => import('@/components/OrderMonitoring/OfflineCardRecord/OfflinePeriodDetail'),
		icon:'#icon-dingdan'
	},{
		name: 'invoiceMgr',
		title:"发票管理",
		component: () => import('@/components/OrderMonitoring/InvoiceInfo/InvoiceInfoManagement'),
		icon:'#icon-lixian'
	},{
		name: 'parkingPushRecord',
		title:"道闸推送记录",
		component: () => import('@/components/OrderMonitoring/ParkingPush/ParkingPushRecord'),
		icon:'#icon-lixian'
	},{
		name: 'stationAnalysis',
		title:"场站分析",
		component: () => import('@/components/StatisticalAnalysis/OperationalAnalysis/StationAnalysis'),
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationAnalysisEvcs',
		title:"互联互通分析",
		component: () => import('@/components/StatisticalAnalysis/OperationalAnalysis/StationAnalysisEvcs'),
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationReports',
		title:"场站报表",
		component: () => import('@/components/StatisticalAnalysis/OperationalAnalysis/StationReports'),
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationReportsEvcs',
		title:"互联互通报表",
		component: () => import('@/components/StatisticalAnalysis/OperationalAnalysis/StationReportsEvcs'),
		icon:'#icon-tongjifenxi3'
	},{
		name: 'onlineRatio',
		title:"在线率",
		component: () => import('@/components/StatisticalAnalysis/EfficiencyAnalysis/OnlineRateInfo/OnlineRateInfo'),
		icon:'ios-speedometer'
	},{
		name: 'useRatio',
		title:"利用率",
		component: () => import('@/components/StatisticalAnalysis/EfficiencyAnalysis/UseRateInfo/UseRateInfo'),
		icon:'ios-speedometer'
	},{
		name: 'attritionRatio',
		title:"损耗率",
		component: () => import('@/components/OperationMonitoring/stationMonitoring/DeviceStatus'),
		icon:'ios-speedometer'
	},{
		name: 'memberInfo',
		title:"会员信息",
		component: () => import('@/components/Member/IndividualMember/MemberInfo'),
		icon:'#icon-qinghuiyuan'
	},{
		name: 'memberTransRecord',
		title:"会员交易记录",
		component: () => import('@/components/Member/IndividualMember/TransactionRecordInfo'),
		icon:'#icon-shouru'
	},{
		name: 'memberStatistics',
		title:"会员统计",
		component: () => import('@/components/Member/MemberStatistics/MemberStatisticsInfo'),
		icon:'#icon-shouru'
	},{
		name: 'memberGroupInfo',
		title:"集团信息",
		component: () => import('@/components/Member/GroupMember/GroupMemberInfo'),
		icon:'#icon-huiyuanqia'
	},{
		name: 'memberGroupAdjunctInfo',
		title:"集团信息",
		component: () => import('@/components/Member/GroupMember/GroupAdjunctInfo'),
		icon:'#icon-huiyuanqia'
	},{
		name: 'memberGroupTransRecord',
		title:"集团交易记录",
		component: () => import('@/components/Member/GroupMember/GroupTransactionRecordInfo'),
		icon:'#icon-shouru'
	},{
		name: 'stationManage',
		title:"场站管理",
		component: () => import('@/components/Archives/StationManagement/StationManagement'),
		icon:'#icon-chongdianzhuang'
	},{
		name: 'equipmentManageCar',
		title:"设备管理(汽车)",
		component: () => import('@/components/Archives/EquipmentManagement/EquipmentManagementCar'),
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'equipmentManageMoto',
		title:"设备管理(电单车)",
		component: () => import('@/components/Archives/EquipmentManagement/EquipmentManagementMoto'),
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'equipmentManageParkingLock',
		title:"设备管理(地锁)",
		component: () => import('@/components/Archives/EquipmentManagement/EquipmentManagementParkingLock'),
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'periodPriceManagement',
		title:"价格管理",
		component: () => import('@/components/Archives/PriceManagement/PriceManagement'),
		icon:'#icon-icon-price'
	},{
		name: 'powerPriceManagement',
		title:"电单车价格",
		component: () => import('@/components/Archives/PriceManagement/PriceManagementPower'),
		icon:'#icon-icon-price'
	},{
		name: 'occupyPriceManagement',
		title:"占位费价格",
		component: () => import('@/components/Archives/PriceManagement/PriceManagementOccupy'),
		icon:'#icon-icon-price'
	},{
		name: 'jfpgPriceManagement',
		title:"价格管理(尖峰平谷)",
		component: () => import('@/components/Archives/PriceManagement/JfpgManagement'),
		icon:'#icon-icon-price'
	},{
		name: 'merchantMgr',
		title:"商户管理",
		component: () => import('@/components/Archives/MerchantManagement/MerchantManagement'),
		icon:'#icon-icon-price'
	},{
		name: 'eventManage',
		title:"事件管理",
		component: () => import('@/components/Archives/EventManagement/EventManagement'),
		icon:'#icon-yuanquyunwei'
	},{
		name: 'couponManage',
		title:"优惠券管理",
		component: () => import('@/components/OperationMonitoring/CouponMonitoring/CouponManagement'),
		icon:'#icon-iconmoban'
	},{
		name: 'stationParkingManage',
		title:"道闸管理",
		component: () => import('@/components/OperationMonitoring/ParkingManage/StationParkingManage'),
		icon:'#icon-iconmoban'
	},{
		name: 'localOperatorMgr',
		title:"运营商管理",
		component: () => import('@/components/Archives/OperatorManageMent/OperatorManageMent'),
		icon:'#icon-yunyingshang'
	},{
		name: 'evcsOperatorsMgr',
		title:"互联互通运营商",
		component: () => import('@/components/Archives/OperatorManageMent/EvcsOperatorManageMent'),
		icon:'#icon-yunyingshang'
	},{
		name: 'parametersManagement',
		title:"设备参数管理",
		component: () => import('@/components/Archives/ParametersManagement/ParametersManagement'),
		icon:'#icon-yunyingshang'
	},{
		name: 'personalInfo',
		title:"个人信息",
		component: () => import('@/components/SysMonitoring/PersonalInformation/PersonalInformation'),
		icon:'ios-speedometer'
	},{
		name: 'roleManage',
		title:"角色管理",
		component: () => import('@/components/SysMonitoring/RoleManagement/RoleManagement'),
		icon:'#icon-quanxianguanli1'
	},{
		name: 'userManage',
		title:"用户管理",
		component: () => import('@/components/SysMonitoring/UserManagement/UserManagement'),
		icon:'#icon-renyuanguanli1'
	},{
		name: 'menuManage',
		title:"菜单管理",
		component: () => import('@/components/SysMonitoring/MenuManagement/MenuManagement'),
		icon:'#icon-quanxianguanli3'
	},{
		name: 'widgetManage',
		title:"控件管理",
		component: () => import('@/components/SysMonitoring/ControlManagement/ControlManagement'),
		icon:'#icon-update'
	},{
		name: 'remoteUpgrade',
		title:"远程升级",
		component: () => import('@/components/SysMonitoring/RemoteUpgrade/RemoteUpgrade'),
		icon:'#icon-quanju_shengji'
	}
];

export default components
